import { SETTING_LOCATION } from "@/shared/utils/settings/constants";
import {
  _getDefaultSettings,
  _getStoredSettings,
  _validateSetting,
  _validateSettings,
} from "@/shared/utils/settings/settings";
import {
  LITE_APP_DEFAULT_SETTINGS_OVERRIDE_MAP,
  LANDING_APP_DEFAULT_SETTINGS_OVERRIDE_MAP,
  LITE_APP_SETTINGS_VALIDATORS,
  LANDING_APP_SETTINGS_VALIDATORS,
} from "./constants";
import { isLandingApp } from "@/utils/assembly";

const _validateSettingsEasyModeApp = (settings, holderFixedSettings) => {
  return _validateSettings(
    settings,
    LITE_APP_SETTINGS_VALIDATORS,
    LITE_APP_DEFAULT_SETTINGS_OVERRIDE_MAP,
    holderFixedSettings,
  );
};

const _validateSettingsLandingApp = (settings, holderFixedSettings) => {
  return _validateSettings(
    settings,
    LANDING_APP_SETTINGS_VALIDATORS,
    LANDING_APP_DEFAULT_SETTINGS_OVERRIDE_MAP,
    holderFixedSettings,
  );
};

export const validateSettingsNextApp = (settings, holderFixedSettings) => {
  return isLandingApp()
    ? _validateSettingsLandingApp(settings, holderFixedSettings)
    : _validateSettingsEasyModeApp(settings, holderFixedSettings);
};

const _validateSettingEasyModeApp = (id, value, holderFixedSettings) => {
  return _validateSetting(
    id,
    value,
    LITE_APP_SETTINGS_VALIDATORS,
    LITE_APP_DEFAULT_SETTINGS_OVERRIDE_MAP,
    holderFixedSettings,
  );
};

const _validateSettingLandingApp = (id, value, holderFixedSettings) => {
  return _validateSetting(
    id,
    value,
    LANDING_APP_SETTINGS_VALIDATORS,
    LANDING_APP_DEFAULT_SETTINGS_OVERRIDE_MAP,
    holderFixedSettings,
  );
};

export const validateSettingNextApp = (id, value, holderFixedSettings) => {
  return isLandingApp()
    ? _validateSettingLandingApp(id, value, holderFixedSettings)
    : _validateSettingEasyModeApp(id, value, holderFixedSettings);
};

const _getStoredSettingsEasyModeApp = () => {
  return _getStoredSettings(SETTING_LOCATION.NEXT_APP, LITE_APP_DEFAULT_SETTINGS_OVERRIDE_MAP);
};

const _getStoredSettingsLandingApp = () => {
  return _getStoredSettings(SETTING_LOCATION.NEXT_APP, LANDING_APP_DEFAULT_SETTINGS_OVERRIDE_MAP);
};

export const getStoredSettingsNextApp = () => {
  return isLandingApp() ? _getStoredSettingsLandingApp() : _getStoredSettingsEasyModeApp();
};

const _getDefaultSettingsEasyModeApp = () => {
  return _getDefaultSettings(SETTING_LOCATION.NEXT_APP, LITE_APP_DEFAULT_SETTINGS_OVERRIDE_MAP);
};

const _getDefaultSettingsLandingApp = () => {
  return _getDefaultSettings(SETTING_LOCATION.NEXT_APP, LANDING_APP_DEFAULT_SETTINGS_OVERRIDE_MAP);
};

export const getDefaultSettingsNextApp = () => {
  return isLandingApp() ? _getDefaultSettingsLandingApp() : _getDefaultSettingsEasyModeApp();
};
